export default function directionToDegrees(direction: string) {
  if (direction === 'up') return '270';
  if (direction === 'left') return '180';
  if (direction === 'down') return '90';
  return '0';
}
